import React from "react";

export default function ThreeDot() {
  return (
    <div className="btn-link" data-bs-toggle="dropdown">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24"></rect>
          <circle fill="#000000" cx="12" cy="5" r="2"></circle>
          <circle fill="#000000" cx="12" cy="12" r="2"></circle>
          <circle fill="#000000" cx="12" cy="19" r="2"></circle>
        </g>
      </svg>
    </div>
  );
}
